import { FileQuestion, Home, ArrowLeft } from 'lucide-react';

import { Button } from './ui/button';

const NotFound = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-blue-50/30 p-4">
      <div className="max-w-lg w-full">
        {/* 404 Card */}
        <div className="relative overflow-hidden rounded-2xl border border-slate-200/60 bg-white shadow-xl shadow-slate-900/10">
          {/* Top gradient bar */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500" />

          <div className="p-8">
            {/* Icon */}
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-blue-100 rounded-full animate-pulse opacity-40" />
                <div className="relative flex items-center justify-center w-24 h-24 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-full border-2 border-blue-100">
                  <FileQuestion className="w-12 h-12 text-blue-500" strokeWidth={1.5} />
                </div>
              </div>
            </div>

            {/* 404 Text */}
            <div className="text-center mb-2">
              <span className="text-6xl font-bold bg-gradient-to-r from-blue-500 to-indigo-500 bg-clip-text text-transparent">
                404
              </span>
            </div>

            {/* Title */}
            <h1 className="text-xl font-bold text-center text-slate-800 mb-2">
              페이지를 찾을 수 없습니다
            </h1>

            {/* Description */}
            <p className="text-center text-slate-500 mb-8">
              요청하신 페이지가 존재하지 않거나
              <br />
              이동되었을 수 있습니다.
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                onClick={() => window.history.back()}
                variant="outline"
                className="flex-1 border-slate-200 hover:bg-slate-50"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                이전 페이지
              </Button>
              <Button
                onClick={() => (window.location.href = '/')}
                className="flex-1 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-lg shadow-blue-500/25"
              >
                <Home className="w-4 h-4 mr-2" />
                홈으로 이동
              </Button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-slate-400 mt-4">
          URL을 다시 확인해 주세요.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
